export default __webpack_public_path__ + "static/media/settingsActive.b4459e86.svg";